import React, { Fragment, useState, useEffect, useCallback } from 'react';
import {
    Row,
    Col,
    Card,
    CardBody,
    Collapse,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    ListGroup,
    ListGroupItem,
    CardHeader,
    // CustomInput,
    Button,
    Container,
    UncontrolledButtonDropdown,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    FormGroup,
    Label
} from 'reactstrap';
// import Select from 'react-select';

// import { faTrashAlt, faCheck } from '@fortawesome/free-solid-svg-icons';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import api from '../../../../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../../../../Context/Auth/AuthContext';
import { useForm } from 'react-hook-form';

export default function NotesList(props) {
    const { 
        id,
        refreshNote,
        setRefreshNote
    } = props;

    const { register, handleSubmit, reset } = useForm({});

    const [notesData, setNotesData] = useState([]);
    const [noNotes, setNoNotes] = useState(false);
    const [currentNote, setCurrentNote] = useState();
    const [accordion, setAccordion] = useState([false, false]);
    const { toggleLoading } = useAuth();

    const [modalEditNote, setModalEditNote] = useState(false);
    const toggleModalEditNote = useCallback(() => {
        setModalEditNote(!modalEditNote);
    }, [setModalEditNote, modalEditNote]);

    const [modalDeleteNote, setModalDeleteNote] = useState(false);
    const toggleModalDeleteNote = useCallback(() => {
        setModalDeleteNote(!modalDeleteNote);
    }, [setModalDeleteNote, modalDeleteNote]);

    const [lastId, setLastId] = useState(null);

    // const options = () => {
    //     let options = [];
    //     notesData.map((receiver) => {
    //         options.push({
    //             value: receiver.id,
    //             label: receiver.name,
    //         });
    //         return null;
    //     });
    //     return options;
    // };

    const getNotes = useCallback(() => {
        toggleLoading(true);
        api.post(`/ro.team.listNotesForGroup/${id.id}`)
            .then((response) => {
                setNotesData(response.data.items);
                setAccordion(response.data.items.map((note) => false));
                setNoNotes(response.data.items.length === 0);
                setLastId(response.data.lastId);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
            });
    }, [id, setNotesData, toggleLoading, setNoNotes, setLastId]);

    const loadMore = useCallback(() => {
        toggleLoading(true);
        api.post(`/ro.team.listNotesForGroup/${id.id}`, {lastId})
            .then((response) => {
                setNotesData([...notesData, ...response.data.items]);
                setAccordion([...notesData, ...response.data.items].map((note) => false));
                setNoNotes([...notesData, ...response.data.items].length === 0);
                setLastId(response.data.lastId);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
            });
    }, [toggleLoading, id, lastId, setNotesData, notesData]);

    useEffect(() => {
        if (refreshNote) {
            getNotes();
            setRefreshNote(false);
        } else {
            getNotes();
        }
    }, [getNotes, refreshNote, setRefreshNote]);    

    const toggleAccordion = (tab) => {
        const prevState = accordion;
        const newState = prevState.map((x, index) =>
            tab === index ? !x : false
        );
        setAccordion(newState);
    };

    const onSubmitEditNote = useCallback(
        async (data) => {
            toggleLoading(true);
            api.patch(`/ro.team.modifyNote/${currentNote.noteId}`, {
                noteText: data.note,
                gid: id.id
            })
                .then((response) => {
                    toast.success(`Note edited`);
                    toggleModalEditNote();
                    reset(response);
                    getNotes();
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                })
                .finally(() => {
                    toggleLoading(false);
                });
        },
        [toggleModalEditNote, reset, id.id, toggleLoading, currentNote, getNotes]
    );

    const onSubmitRemoveNote = useCallback(
        async () => {
            toggleLoading(true);
            api.delete(`/ro.team.removeNote/${currentNote.noteId}`, {
                data: {
                    gid: id.id
                }
            })
                .then((response) => {
                    toast.success(`Note removed`);
                    toggleModalDeleteNote();
                    reset(response);
                    getNotes();
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                })
                .finally(() => {
                    toggleLoading(false);
                });
        },
        [toggleModalDeleteNote, reset, id.id, toggleLoading, currentNote, getNotes]
    );

    const getDate = useCallback((date) => {
        date = String(date);
        return `${date.slice(4,6)}/${date.slice(6,8)}/${date.slice(0,4)}`;
    }, []);

    return (
        <Fragment>
            <Container fluid>
                <Row className="mb-4">
                    <Col lg="12">
                        {/* <Select
                            options={options()}
                            placeholder="Select to Filter"
                        /> */}
                    </Col>
                </Row>
                <Row>
                    <Col lg="12">
                        <Card className="main-card mb-3">
                            <ListGroup className="todo-list-wrapper" flush>
                                {notesData &&
                                    notesData.map((noteItem, noteIndex) => (
                                        <ListGroupItem key={noteItem.noteId}>
                                            <div
                                                id="accordion"
                                                className="accordion-wrapper mb-3"
                                            >
                                                <Card>
                                                    <CardHeader id="headingOne">
                                                        <div style={{width: '100%'}} >
                                                            <div className="widget-content p-0">
                                                                <div className="widget-content-wrapper">
                                                                    <div className="widget-content-left">
                                                                        <Button
                                                                            block
                                                                            color="link"
                                                                            className="text-left m-0 p-0"
                                                                            onClick={() =>
                                                                                toggleAccordion(
                                                                                    noteIndex
                                                                                )
                                                                            }
                                                                            aria-expanded={
                                                                                accordion[
                                                                                    noteIndex
                                                                                ]
                                                                            }
                                                                            aria-controls="collapseOne"
                                                                        >
                                                                            <h5 className="m-0 p-0">
                                                                                {
                                                                                    `${getDate(noteItem.createdAt)} by ${noteItem.by}`
                                                                                }
                                                                            </h5>
                                                                        </Button>
                                                                    </div>

                                                                    <div className="widget-content-right">
                                                                        <UncontrolledButtonDropdown direction="left">
                                                                            <DropdownToggle color="primary">
                                                                                <FontAwesomeIcon
                                                                                    icon={
                                                                                        faBars
                                                                                    }
                                                                                    size="1x"
                                                                                />
                                                                            </DropdownToggle>
                                                                            <DropdownMenu className="no-arrow">
                                                                                <DropdownItem
                                                                                    onClick={() => {
                                                                                        setCurrentNote(noteItem);
                                                                                        toggleModalEditNote();
                                                                                    }}
                                                                                >
                                                                                    Edit
                                                                                </DropdownItem>
                                                                                <DropdownItem
                                                                                    onClick={() => {
                                                                                        setCurrentNote(noteItem);
                                                                                        toggleModalDeleteNote();
                                                                                    }}
                                                                                >
                                                                                    Delete
                                                                                </DropdownItem>
                                                                            </DropdownMenu>
                                                                        </UncontrolledButtonDropdown>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </CardHeader>
                                                    <Collapse
                                                        isOpen={
                                                            accordion[noteIndex]
                                                        }
                                                        data-parent="#accordion"
                                                        id="collapseOne"
                                                        aria-labelledby="headingOne"
                                                    >
                                                        <CardBody>
                                                            {noteItem.nt}
                                                        </CardBody>
                                                    </Collapse>
                                                </Card>
                                            </div>
                                        </ListGroupItem>
                                    ))}
                            </ListGroup>
                            {noNotes && (
                                <CardBody>
                                    <p>This Group doesn't have any Notes yet</p>
                                </CardBody>
                            )}
                        </Card>

                        {lastId !== null && (
                            <div className="text-center">
                                <Button
                                    className="btn-wide mb-2 mr-2"
                                    size="md"
                                    color="info"
                                    onClick={loadMore}
                                >
                                    Load more
                                </Button>
                            </div>
                        )}

                    </Col>
                </Row>

                <Modal isOpen={modalEditNote} toggle={toggleModalEditNote}>
                    <ModalHeader toggle={toggleModalEditNote}>
                        Edit Note
                    </ModalHeader>
                    <ModalBody>
                        <Form>
                            <FormGroup row>
                                <Label for="note" sm={2}>
                                    Note
                                </Label>
                                <Col sm={10}>
                                    <textarea
                                        name="note"
                                        id="note"
                                        ref={register}
                                        className="form-control"
                                        rows="2"
                                        defaultValue={currentNote && currentNote.nt}
                                    />
                                </Col>
                            </FormGroup>
                            <div className="text-center">
                                <Button
                                    className="btn-wide mb-2 mr-2"
                                    size="md"
                                    color="info"
                                    onClick={handleSubmit(onSubmitEditNote)}
                                >
                                    OK
                                </Button>

                                <Button
                                    className="btn-wide mb-2 mr-2"
                                    size="md"
                                    color="secondary"
                                    onClick={toggleModalEditNote}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </Form>
                    </ModalBody>
                </Modal>

                <Modal isOpen={modalDeleteNote} toggle={toggleModalDeleteNote}>
                    <ModalHeader toggle={toggleModalDeleteNote}>
                        Confirm Remove Need
                    </ModalHeader>
                    <ModalBody>
                        <Form>
                            <FormGroup row>
                                <Label for="need" sm={2}>
                                    Need
                                </Label>
                                <Col sm={10}>
                                    <textarea
                                        name="note"
                                        id="note"
                                        className="form-control"
                                        rows="2"
                                        defaultValue={currentNote && currentNote.nt}
                                        disabled={true}
                                    />
                                </Col>
                            </FormGroup>
                            <div className="text-center">
                                <Button
                                    className="btn-wide mb-2 mr-2"
                                    size="md"
                                    color="danger"
                                    onClick={onSubmitRemoveNote}
                                >
                                    Remove
                                </Button>

                                <Button
                                    className="btn-wide mb-2 mr-2"
                                    size="md"
                                    color="primary"
                                    onClick={toggleModalDeleteNote}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </Form>
                    </ModalBody>
                </Modal>


            </Container>
        </Fragment>
    );
}
